import { useEffect, useState } from 'react';
import { useAuth } from '../../Context/MyContext';
import { useNavigate } from 'react-router-dom';
import { getCookie } from '../../Utils/cookies';

const Login = () => {
  const Navigate = useNavigate();
  const { setEmpData, loginAPI } = useAuth();

  useEffect(() => {
    const token = getCookie('token');
    const empData = getCookie('empData');
    if (token && empData) {
      const getEmpData = getCookie('empData');
      setEmpData(JSON.parse(getEmpData));
      Navigate('/dashboard');
    }
  }, [Navigate, setEmpData]);

  const [empIdOrMobile, setEmpIdOrMobile] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const imgPartStyles = {
    height: "100vh",
    width: "100%",
    background: "linear-gradient( to right, #FED438, white)"
  };
  const logoBg = {
    background: "linear-gradient( to bottom ,  #FED438, white)",
    height: '7rem',
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const loginData = {
      empIdOrMobile,
      password
    };
    loginAPI(loginData, setError, setLoading);
  };

  return (
    <>
      <div className="flex flex-col md:flex-row min-h-screen w-screen md:h-screen">
        {/* Left Side - Hidden on mobile */}
        <div className="hidden md:flex md:basis-1/2 flex-col justify-center items-center h-screen" style={imgPartStyles}>
          <div className="px-6 md:px-0">
            <h1 className='text-3xl md:text-5xl font-bold pb-3 tracking-wide'>
              <span className='text-dark'>WELCOME</span> <br />
              <span>TO GALO ENERGY</span>
            </h1>
            <p className='text-dark font-semibold pt-3 tracking-wide not-italic hover:italic text-sm md:text-base'>
              Connecting <br /> You to Seamless Solutions.<br />
              Your Trusted Partner, Always With in Reach.
            </p>
          </div>
        </div>
        {/* Right Side */}
        <div className="md:basis-1/2 flex justify-center items-center h-1/2 md:h-screen bg-white min-h-screen">
          <div className="login-container lg:border rounded-lg w-full max-w-md mx-4 md:mx-0 flex flex-col justify-center items-center">
            <div className="logoContainer flex justify-center items-center w-full rounded-lg" style={logoBg}>
              <h1 className='text-3xl md:text-5xl font-bold'>GALO</h1>
            </div>
            <div className='p-6 md:p-12 w-full flex flex-col justify-center items-center'>
              <h1 className='text-2xl md:text-3xl font-bold'>Login</h1>
              <p className='font-normal tracking-wide text-slate-400 text-xs mt-2 w-full text-center md:text-left'>
                Enter your personal details and start work<br />  with us.
              </p>
              <form onSubmit={handleSubmit} className="w-full flex flex-col justify-center items-center">
                <div className='mt-4 w-full'>
                  <label htmlFor="empIdOrMobile" className='font-mono subpixel-antialiased'>User Id:</label>
                  <input
                    type="text"
                    id="empIdOrMobile"
                    value={empIdOrMobile}
                    onChange={(e) => setEmpIdOrMobile(e.target.value)}
                    required
                    className='block w-full rounded-md border-0 py-1.5 pl-7 mt-1 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm/6'
                  />
                </div>
                <div className='mt-4 w-full'>
                  <label htmlFor="password" className='font-mono subpixel-antialiased'>Password:</label>
                  <input
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className='block w-full rounded-md border-0 py-1.5 pl-7 pr-20 mt-1 my-1 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm/6'
                  />
                </div>
                {error && <p style={{ color: "red" }}>{error}</p>}
                <p className='font-normal tracking-wide text-slate-400 text-xs pb-5 text-right w-full'>Forgot Your Password.?</p>
                <div className="w-full">
                  <button type="submit" disabled={loading} className="rounded-md w-full px-2.5 py-1.5 text-md font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 firstBgColor">
                    {loading ? "Logging in..." : "Login"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            .login-container {
              min-height: 100vh;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .logoContainer {
              justify-content: center !important;
              align-items: center !important;
            }
          }
        `}
      </style>
    </>
  );
};

export default Login;
